import React from 'react';
import PartiesForm from './PartiesForm';

const NewPartyPage = () => {
  return (
    <>
     <PartiesForm formType='create' currentPartyId={null} />
    </>
  );
};

export default NewPartyPage;